export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20streetwear%20fashion%20editorial%20scene%20with%20multiple%20colorful%20sneakers%20arranged%20in%20artistic%20composition%20on%20warm%20neutral%20surface%2C%20mixed%20textures%20of%20leather%20mesh%20and%20suede%2C%20dramatic%20side%20lighting%20with%20soft%20shadows%2C%20rich%20earth%20tones%20and%20muted%20colors%2C%20high%20end%20fashion%20catalog%20photography%2C%20sophisticated%20lifestyle%20atmosphere%20with%20depth%20and%20dimension&width=1920&height=1080&seq=hero-main-v2&orientation=landscape"
          alt="CSSBuy Spreadsheet - Produtos Streetwear"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/30 z-[1]"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 md:px-10 flex flex-col lg:flex-row items-center lg:items-end justify-between gap-12 lg:gap-20">
        {/* Left Side - Main Content */}
        <div className="flex-1 flex flex-col items-start text-left pt-20 lg:pt-0 lg:pb-24">
          {/* Social Proof */}
          <div className="flex items-center gap-3 mb-6 animate-fade-in-up">
            <div className="flex -space-x-3">
              <div className="w-10 h-10 rounded-full border-2 border-white/80 bg-accent-400 flex items-center justify-center">
                <span className="text-white text-xs font-bold">LM</span>
              </div>
              <div className="w-10 h-10 rounded-full border-2 border-white/80 bg-secondary-400 flex items-center justify-center">
                <span className="text-white text-xs font-bold">BR</span>
              </div>
              <div className="w-10 h-10 rounded-full border-2 border-white/80 bg-primary-400 flex items-center justify-center">
                <span className="text-white text-xs font-bold">GS</span>
              </div>
            </div>
            <span className="text-white/90 text-sm font-medium">10k+ usuários confiam</span>
          </div>

          {/* H1 Title */}
          <h1 className="text-4xl md:text-5xl lg:text-7xl font-heading font-bold text-white mb-4 animate-fade-in-up-delay-1 leading-tight">
            Melhor CSSBuy<br />
            <span className="font-normal">Spreadsheet 2026</span>
          </h1>

          {/* Description */}
          <p className="text-white/80 text-base md:text-lg max-w-lg mb-8 animate-fade-in-up-delay-2 leading-relaxed">
            O maior diretório de CSSBuy Spreadsheet do Brasil. Tênis, roupas, streetwear, acessórios e produtos selecionados diariamente.
          </p>

          {/* Trust Badges */}
          <div className="flex flex-wrap gap-4 mb-8 animate-fade-in-up-delay-2">
            <span className="flex items-center gap-2 text-white/80 text-sm">
              <i className="ri-check-line text-green-400"></i> Atualizado diariamente
            </span>
            <span className="flex items-center gap-2 text-white/80 text-sm">
              <i className="ri-shield-check-line text-green-400"></i> Compra segura
            </span>
            <span className="flex items-center gap-2 text-white/80 text-sm">
              <i className="ri-image-line text-green-400"></i> QC incluído
            </span>
            <span className="flex items-center gap-2 text-white/80 text-sm">
              <i className="ri-global-line text-green-400"></i> Frete internacional
            </span>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-up-delay-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-2 bg-white text-foreground-950 font-semibold px-8 py-3.5 rounded-full whitespace-nowrap hover:bg-background-100 transition-colors duration-200 cursor-pointer text-sm"
            >
              CSSBuy Sheet
              <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-2 bg-accent-500 text-white font-semibold px-8 py-3.5 rounded-full whitespace-nowrap hover:bg-accent-600 transition-colors duration-200 cursor-pointer text-sm"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>
          </div>
        </div>

        {/* Right Side - Info Card */}
        <div className="flex-1 flex justify-end lg:pb-24">
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 md:p-8 max-w-sm shadow-sm animate-fade-in-up-delay-2">
            <p className="text-foreground-700 text-sm leading-relaxed">
              Encontre os melhores produtos, links e planilhas atualizadas do CSSBuy. Nossa seleção inclui apenas links verificados e os melhores vendedores da plataforma.
            </p>
            <div className="mt-4 pt-4 border-t border-background-200">
              <a
                href="/artigo/cssbuy-spreadsheet-guia-completo"
                className="inline-flex items-center gap-1 text-accent-500 hover:text-accent-600 font-medium text-sm whitespace-nowrap cursor-pointer transition-colors"
              >
                Ler guia completo
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}